import React from "react";
import { Link } from "react-router-dom";
import { Blog, Pagination } from "../../components/";
import blogData from "../../data/blog.json";

// Slugify function
const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // remove symbols
    .trim()
    .replace(/\s+/g, "-"); // replace spaces with -
};

const BlogThree = ({ ...restProps }) => (
  <div {...restProps}>
    <div className="container">
      <div className="row">
        {blogData.map((post) => {
          const slug = slugify(post.title); // ✅ Declare before return
          return (
            <div className="col-md-6 col-lg-4" key={post.id}>
              <Blog className="blog-style1">
                <Blog.Image path={`/blog/${slug}`} src={post.image} />
                <Blog.Body>
                  <Blog.Meta>
                    <Link to={`/blog/${slug}`}>
                      <i className="far fa-calendar" /> {post.date}
                    </Link>
                    <Link to={`/blog/${slug}`}>
                      <i className="fal fa-user" /> {post.authorName}
                    </Link>
                  </Blog.Meta>
                  <Blog.Title className="h5" path={`/blog/${slug}`}>
                    {post.title}
                  </Blog.Title>
                  <Link to={`/blog/${slug}`} className="link-btn">
                    Read Details <i className="far fa-arrow-right"></i>
                  </Link>
                </Blog.Body>
              </Blog>
            </div>
          );
        })}
      </div>

      <div className="pt-20 text-center">
        <Pagination />
      </div>
    </div>
  </div>
);

export default BlogThree;
